
// // PackagesComponent.jsx
// import React, { useState } from 'react';
// import { Check, Star, MessageCircle, Plus, X, ShoppingCart } from 'lucide-react';

// const PackagesComponent = () => {
//   // Configuration
//   const whatsappNumber = "917289007800";

//   // State to track selected add-ons
//   const [selectedAddOns, setSelectedAddOns] = useState([]);

//   // Toggle Add-On Selection
//   const toggleAddOn = (service) => {
//     setSelectedAddOns((prev) => {
//       const exists = prev.find((item) => item.id === service.id);
//       if (exists) {
//         return prev.filter((item) => item.id !== service.id);
//       } else {
//         return [...prev, service];
//       }
//     });
//   };

//   // Clear all selections
//   const clearSelections = () => {
//     setSelectedAddOns([]);
//   };

//   // Helper to calculate add-on total
//   const getAddOnsTotal = () => {
//     return selectedAddOns.reduce((total, addon) => {
//       const priceNum = parseFloat(addon.price.replace(/[^0-9.]/g, '')) || 0;
//       return total + priceNum;
//     }, 0);
//   };

//   // Handle WhatsApp for Package + AddOns
//   const handleWhatsAppBuy = (pkg) => {
//     const packageLine = `📦 *Package:* ${pkg.title} - $${pkg.price.toFixed(2)}`;
    
//     let addOnsText = '';
//     const addOnsTotal = getAddOnsTotal();

//     if (selectedAddOns.length > 0) {
//       addOnsText = '\n\n➕ *Selected Add-Ons:*';
//       selectedAddOns.forEach((addon) => {
//         addOnsText += `\n• ${addon.name} - ${addon.price}`;
//       });
//     }

//     const totalAmount = pkg.price + addOnsTotal;
//     const totalLine = `\n\n💰 *Total Estimate:* $${totalAmount.toFixed(2)}`;
    
//     const message = `Hi Paxgrow, I would like to book the following:\n\n${packageLine}${addOnsText}${totalLine}\n\nPlease assist me with the next steps.`;
    
//     const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   // Handle WhatsApp for Add-Ons ONLY
//   const handleWhatsAppAddOnsOnly = () => {
//     if (selectedAddOns.length === 0) return;

//     let addOnsText = '➕ *Requesting Add-On Services Only:*';
//     const addOnsTotal = getAddOnsTotal();

//     selectedAddOns.forEach((addon) => {
//       addOnsText += `\n• ${addon.name} - ${addon.price}`;
//     });

//     const totalLine = `\n\n💰 *Total Estimate:* $${addOnsTotal.toFixed(2)}`;
    
//     const message = `Hi Paxgrow, I am interested in these Add-On services:\n\n${addOnsText}${totalLine}\n\nPlease provide more details.`;
    
//     const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   const carePackages = [
//     {
//       id: 1,
//       title: 'Integrated Medicine',
//       price: 33.00,
//       highlight: 'Tele-Medicine',
//       description: 'Online Consultation with 4 Doctors at once',
//       features: [
//         'Allopathy Consultation',
//         'Ayurveda Consultation',
//         'Yoga Consultation',
//         'Homeopathy Consultation',
//         'Tele-Conference & Tele-Medicine',
//       ],
//       popular: false,
//     },
//     {
//       id: 2,
//       title: 'India Travel - Basic',
//       price: 172.00,
//       highlight: 'Hotel-Hospital Transfer',
//       description: 'Online Consultation with Indian Doctor & Travel Assistance',
//       features: [
//         'Online Consultation with Indian Doctor',
//         'Visa Assistance',
//         'Airport Transfers',
//         'One Hotel - Hospital Transfer',
//         '1 Doctor\'s Consultation Included',
//       ],
//       popular: false,
//     },
//     {
//       id: 3,
//       title: 'India Travel - Standard',
//       price: 350.00,
//       highlight: 'Comprehensive Care',
//       description: 'Complete travel & medical assistance package',
//       features: [
//         'Online Consultation with Indian Doctor',
//         'Ticket Booking & Visa Assistance',
//         'Airport Transfers',
//         'Indian Sim Card (1 GB Internet)',
//         '2 Doctor\'s Consultations',
//         'Pathological Test Assistance',
//         'Hospitalisation Assistance',
//         'FRRO - Police Verifications',
//         '24x7 Medical Emergency Assistance',
//         'Translator Assistance',
//       ],
//       popular: false,
//     },
//     {
//       id: 4,
//       title: 'India Travel - Premium',
//       price: 399.00,
//       highlight: 'All Inclusive + Concierge',
//       description: 'Premium package with concierge services',
//       features: [
//         'Everything in Standard',
//         '2 Doctor\'s Consultations (Charges Included)',
//         'Concierge Services',
//         'Priority Translator Assistance',
//         'Premium Hotel Transfers',
//         '24x7 Dedicated Support',
//       ],
//       popular: true,
//     },
//   ];

//   const addOnServices = [
//     { id: 1, name: 'Online Doctor Consultation', unit: 'per Consultation', price: '$20.00' },
//     { id: 2, name: 'Doctor Consultation in INDIA', unit: 'per Consultation', price: '$29.00' },
//     { id: 3, name: 'Translator Services', unit: 'per day', price: '$50.00' },
//     { id: 4, name: 'Taxi Services', unit: 'per day', price: '$40.00' },
//     { id: 5, name: 'Concierge Services', unit: '', price: '$25.00' },
//     { id: 6, name: 'Airport Transfers (Home)', unit: '', price: '$35.00' },
//     { id: 7, name: 'Sim Card (1GB) in INDIA', unit: 'No Intl Calls', price: '$10.00' },
//     { id: 8, name: 'Health Check up', unit: '', price: 'As per Check up' },
//     { id: 9, name: 'Indian Tourism', unit: '', price: 'As per Req' },
//   ];

//   return (
//     <section className="py-20 px-4 min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
//       <div className="max-w-7xl mx-auto">
        
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
//             <span className="text-red-600">Paxgrow</span> Care Packages
//           </h2>
//           <p className="text-lg text-slate-600 max-w-2xl mx-auto">
//             Select a package or customize your own request with add-on services below.
//           </p>
//         </div>

//         {/* Care Packages Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch mb-16">
//           {carePackages.map((pkg) => (
//             <div
//               key={pkg.id}
//               className={`relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col h-full ${
//                 pkg.popular
//                   ? 'ring-2 ring-red-500 border-t-4 border-red-600 transform md:-translate-y-4'
//                   : 'border-t-4 border-slate-800'
//               }`}
//             >
//               {pkg.popular && (
//                 <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
//                   <div className="flex items-center gap-1 bg-gradient-to-r from-red-600 to-red-500 text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
//                     <Star className="w-3 h-3 fill-current" />
//                     MOST POPULAR
//                   </div>
//                 </div>
//               )}

//               <div className="mb-4">
//                 <h3 className="text-xl font-bold text-slate-900 mb-2">{pkg.title}</h3>
//                 <span className="inline-block bg-red-50 text-red-600 px-3 py-1 rounded-full text-xs font-semibold">
//                   {pkg.highlight}
//                 </span>
//               </div>

//               <div className="mb-4">
//                 <div className="flex items-baseline gap-1">
//                   <span className="text-2xl font-semibold text-slate-900">$</span>
//                   <span className="text-4xl font-bold text-slate-900">
//                     {pkg.price.toFixed(0)}
//                   </span>
//                   <span className="text-lg text-slate-500">
//                     .{pkg.price.toFixed(2).split('.')[1]}
//                   </span>
//                   <span className="text-sm text-slate-500 ml-1">USD</span>
//                 </div>
//               </div>

//               <p className="text-slate-600 text-sm mb-4 min-h-[40px]">
//                 {pkg.description}
//               </p>

//               <ul className="space-y-3 flex-grow mb-6">
//                 {pkg.features.map((feature, idx) => (
//                   <li key={idx} className="flex items-start gap-2.5 text-sm">
//                     <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5">
//                       <Check className="w-3 h-3 text-green-600 stroke-[3]" />
//                     </div>
//                     <span className="text-slate-700">{feature}</span>
//                   </li>
//                 ))}
//               </ul>

//               <button
//                 onClick={() => handleWhatsAppBuy(pkg)}
//                 className={`w-full py-3 px-4 rounded-xl font-semibold text-sm transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg ${
//                   pkg.popular
//                     ? 'bg-red-600 text-white hover:bg-red-700'
//                     : 'bg-slate-900 text-white hover:bg-slate-800'
//                 }`}
//               >
//                 <MessageCircle className="w-4 h-4" />
//                 Buy via WhatsApp
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Add-On Services Section */}
//         <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 shadow-inner border border-slate-200">
//           <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
//             <div>
//               <h3 className="text-2xl font-bold text-slate-900">Add-On Services</h3>
//               <p className="text-slate-600 text-sm">
//                 Click to select services. You can add them to a package or request them separately.
//               </p>
//             </div>
            
//             {selectedAddOns.length > 0 && (
//               <div className="flex items-center gap-3 bg-red-50 px-4 py-2 rounded-full border border-red-200">
//                 <span className="text-sm font-semibold text-red-700">
//                   {selectedAddOns.length} Service{selectedAddOns.length !== 1 ? 's' : ''} Selected
//                 </span>
//                 <button 
//                   onClick={clearSelections}
//                   className="text-xs text-red-600 hover:text-red-800 font-medium flex items-center gap-1"
//                 >
//                   <X className="w-3 h-3" /> Clear
//                 </button>
//               </div>
//             )}
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
//             {addOnServices.map((service) => {
//               const isSelected = selectedAddOns.some((item) => item.id === service.id);
              
//               return (
//                 <div
//                   key={service.id}
//                   onClick={() => toggleAddOn(service)}
//                   className={`cursor-pointer rounded-xl p-5 shadow-md transition-all duration-300 border-l-4 flex justify-between items-center gap-4 group min-h-[90px] select-none ${
//                     isSelected
//                       ? 'bg-red-50 border-red-600 shadow-lg translate-x-1'
//                       : 'bg-white border-red-500 hover:shadow-xl hover:translate-x-1'
//                   }`}
//                 >
//                   <div className="flex-1">
//                     <h4 className={`font-semibold text-sm md:text-base transition-colors ${
//                       isSelected ? 'text-red-700' : 'text-slate-900 group-hover:text-red-600'
//                     }`}>
//                       {service.name}
//                     </h4>
//                     {service.unit && (
//                       <span className={`text-xs italic ${
//                         isSelected ? 'text-red-600/70' : 'text-slate-500'
//                       }`}>
//                         {service.unit}
//                       </span>
//                     )}
//                   </div>
                  
//                   <div className="flex items-center gap-3">
//                     <span className={`text-lg font-bold whitespace-nowrap ${
//                       isSelected ? 'text-red-600' : 'text-red-600'
//                     }`}>
//                       {service.price}
//                     </span>
                    
//                     <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${
//                       isSelected 
//                         ? 'bg-red-600 text-white' 
//                         : 'bg-slate-100 text-slate-400 group-hover:bg-red-100 group-hover:text-red-500'
//                     }`}>
//                       {isSelected ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Add-Ons Only Action Button */}
//           {selectedAddOns.length > 0 && (
//             <div className="flex justify-center mt-4">
//               <button
//                 onClick={handleWhatsAppAddOnsOnly}
//                 className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-8 py-4 rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-3 transform hover:-translate-y-1"
//               >
//                 {/* <ShoppingCart className="w-5 h-5" /> */}
//                 Request Add-Ons Only via WhatsApp
//                 <span className="bg-white/20 px-2 py-0.5 rounded-md text-sm ml-1">
//                   {selectedAddOns.length} Selected
//                 </span>
//               </button>
//             </div>
//           )}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default PackagesComponent;




// PackagesComponent.jsx
import React, { useState } from 'react';
import { Check, Star, MessageCircle, Plus, X, ShoppingCart } from 'lucide-react';

const PackagesComponent = () => {
  // Configuration
  const whatsappNumber = "917289007800";

  // State to track selected add-ons
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  // Toggle Add-On Selection
  const toggleAddOn = (service) => {
    setSelectedAddOns((prev) => {
      const exists = prev.find((item) => item.id === service.id);
      if (exists) {
        return prev.filter((item) => item.id !== service.id);
      } else {
        return [...prev, service];
      }
    });
  };

  // Clear all selections
  const clearSelections = () => {
    setSelectedAddOns([]);
  };

  // Helper to calculate add-on total
  const getAddOnsTotal = () => {
    return selectedAddOns.reduce((total, addon) => {
      const priceNum = parseFloat(addon.price.replace(/[^0-9.]/g, '')) || 0;
      return total + priceNum;
    }, 0);
  };

  // 📱 Generate Impressive WhatsApp Message for Package
  const handleWhatsAppBuy = (pkg) => {
    const addOnsTotal = getAddOnsTotal();
    const totalAmount = pkg.price + addOnsTotal;

    let addOnsSection = '';
    if (selectedAddOns.length > 0) {
      addOnsSection = '\n\n SELECTED ADD-ONS \n━━━━━━━━━━━━━━━━━━\n';
      selectedAddOns.forEach((addon) => {
        addOnsSection += `• ${addon.name} — ${addon.price}\n`;
      });
    }

    const message = ` Hi Paxgrow Team!

I would like to book a healthcare package. Here are the details:

 PACKAGE DETAILS
━━━━━━━━━━━━━━━━━━
 Name: ${pkg.title}
 Price: $${pkg.price.toFixed(2)}${addOnsSection}

 TOTAL ESTIMATE
━━━━━━━━━━━━━━━━━━
 Total: $${totalAmount.toFixed(2)}

 Please assist me with the booking process and next steps. Thank you! `;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // 📱 Generate Impressive WhatsApp Message for Add-Ons Only
  const handleWhatsAppAddOnsOnly = () => {
    if (selectedAddOns.length === 0) return;

    const addOnsTotal = getAddOnsTotal();

    let servicesList = '';
    selectedAddOns.forEach((addon) => {
      servicesList += `• ${addon.name} — ${addon.price}\n`;
    });

    const message = ` Hi Paxgrow Team!

I am interested in purchasing specific Add-On services. Here is my list:

 REQUESTED SERVICES
━━━━━━━━━━━━━━━━━━
${servicesList}
 TOTAL ESTIMATE
━━━━━━━━━━━━━━━━━━
 Total: $${addOnsTotal.toFixed(2)}

 Could you please provide more details and assist with the booking? Thank you! `;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const carePackages = [
    {
      id: 1,
      title: 'Integrated Medicine',
      price: 33.00,
      highlight: 'Tele-Medicine',
      description: 'Online Consultation with 4 Doctors at once',
      features: [
        'Allopathy Consultation',
        'Ayurveda Consultation',
        'Yoga Consultation',
        'Homeopathy Consultation',
        'Tele-Conference & Tele-Medicine',
      ],
      popular: false,
    },
    {
      id: 2,
      title: 'India Travel - Basic',
      price: 172.00,
      highlight: 'Hotel-Hospital Transfer',
      description: 'Online Consultation with Indian Doctor & Travel Assistance',
      features: [
        'Online Consultation with Indian Doctor',
        'Visa Assistance',
        'Airport Transfers',
        'One Hotel - Hospital Transfer',
        '1 Doctor\'s Consultation Included',
      ],
      popular: false,
    },
    {
      id: 3,
      title: 'India Travel - Standard',
      price: 350.00,
      highlight: 'Comprehensive Care',
      description: 'Complete travel & medical assistance package',
      features: [
        'Online Consultation with Indian Doctor',
        'Ticket Booking & Visa Assistance',
        'Airport Transfers',
        'Indian Sim Card (1 GB Internet)',
        '2 Doctor\'s Consultations',
        'Pathological Test Assistance',
        'Hospitalisation Assistance',
        'FRRO - Police Verifications',
        '24x7 Medical Emergency Assistance',
        'Translator Assistance',
      ],
      popular: false,
    },
    {
      id: 4,
      title: 'India Travel - Premium',
      price: 399.00,
      highlight: 'All Inclusive + Concierge',
      description: 'Premium package with concierge services',
      features: [
        'Everything in Standard',
        '2 Doctor\'s Consultations (Charges Included)',
        'Concierge Services',
        'Priority Translator Assistance',
        'Premium Hotel Transfers',
        '24x7 Dedicated Support',
      ],
      popular: true,
    },
  ];

  const addOnServices = [
    { id: 1, name: 'Online Doctor Consultation', unit: 'per Consultation', price: '$20.00' },
    { id: 2, name: 'Doctor Consultation in INDIA', unit: 'per Consultation', price: '$29.00' },
    { id: 3, name: 'Translator Services', unit: 'per day', price: '$50.00' },
    { id: 4, name: 'Taxi Services', unit: 'per day', price: '$40.00' },
    { id: 5, name: 'Concierge Services', unit: '', price: '$25.00' },
    { id: 6, name: 'Airport Transfers (Home)', unit: '', price: '$35.00' },
    { id: 7, name: 'Sim Card (1GB) in INDIA', unit: 'No Intl Calls', price: '$10.00' },
    { id: 8, name: 'Health Check up', unit: '', price: 'As per Check up' },
    { id: 9, name: 'Indian Tourism', unit: '', price: 'As per Req' },
  ];

  return (
    <section className="py-20 px-4 min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            <span className="text-red-600">Paxgrow</span> Care Packages
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Select a package or customize your own request with add-on services below.
          </p>
        </div>

        {/* Care Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch mb-16">
          {carePackages.map((pkg) => (
            <div
              key={pkg.id}
              className={`relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col h-full ${
                pkg.popular
                  ? 'ring-2 ring-red-500 border-t-4 border-red-600 transform md:-translate-y-4'
                  : 'border-t-4 border-slate-800'
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
                  <div className="flex items-center gap-1 bg-gradient-to-r from-red-600 to-red-500 text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    <Star className="w-3 h-3 fill-current" />
                    MOST POPULAR
                  </div>
                </div>
              )}

              <div className="mb-4">
                <h3 className="text-xl font-bold text-slate-900 mb-2">{pkg.title}</h3>
                <span className="inline-block bg-red-50 text-red-600 px-3 py-1 rounded-full text-xs font-semibold">
                  {pkg.highlight}
                </span>
              </div>

              <div className="mb-4">
                <div className="flex items-baseline gap-1">
                  <span className="text-2xl font-semibold text-slate-900">$</span>
                  <span className="text-4xl font-bold text-slate-900">
                    {pkg.price.toFixed(0)}
                  </span>
                  <span className="text-lg text-slate-500">
                    .{pkg.price.toFixed(2).split('.')[1]}
                  </span>
                  <span className="text-sm text-slate-500 ml-1">USD</span>
                </div>
              </div>

              <p className="text-slate-600 text-sm mb-4 min-h-[40px]">
                {pkg.description}
              </p>

              <ul className="space-y-3 flex-grow mb-6">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2.5 text-sm">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5">
                      <Check className="w-3 h-3 text-green-600 stroke-[3]" />
                    </div>
                    <span className="text-slate-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => handleWhatsAppBuy(pkg)}
                className={`w-full py-3 px-4 rounded-xl font-semibold text-sm transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg ${
                  pkg.popular
                    ? 'bg-red-600 text-white hover:bg-red-700'
                    : 'bg-slate-900 text-white hover:bg-slate-800'
                }`}
              >
                <MessageCircle className="w-4 h-4" />
                Buy via WhatsApp
              </button>
            </div>
          ))}
        </div>

        {/* Add-On Services Section */}
        <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 shadow-inner border border-slate-200">
          <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
            <div>
              <h3 className="text-2xl font-bold text-slate-900">Add-On Services</h3>
              <p className="text-slate-600 text-sm">
                Click to select services. You can add them to a package or request them separately.
              </p>
            </div>
            
            {selectedAddOns.length > 0 && (
              <div className="flex items-center gap-3 bg-red-50 px-4 py-2 rounded-full border border-red-200">
                <span className="text-sm font-semibold text-red-700">
                  {selectedAddOns.length} Service{selectedAddOns.length !== 1 ? 's' : ''} Selected
                </span>
                <button 
                  onClick={clearSelections}
                  className="text-xs text-red-600 hover:text-red-800 font-medium flex items-center gap-1"
                >
                  <X className="w-3 h-3" /> Clear
                </button>
              </div>
            )}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {addOnServices.map((service) => {
              const isSelected = selectedAddOns.some((item) => item.id === service.id);
              
              return (
                <div
                  key={service.id}
                  onClick={() => toggleAddOn(service)}
                  className={`cursor-pointer rounded-xl p-5 shadow-md transition-all duration-300 border-l-4 flex justify-between items-center gap-4 group min-h-[90px] select-none ${
                    isSelected
                      ? 'bg-red-50 border-red-600 shadow-lg translate-x-1'
                      : 'bg-white border-red-500 hover:shadow-xl hover:translate-x-1'
                  }`}
                >
                  <div className="flex-1">
                    <h4 className={`font-semibold text-sm md:text-base transition-colors ${
                      isSelected ? 'text-red-700' : 'text-slate-900 group-hover:text-red-600'
                    }`}>
                      {service.name}
                    </h4>
                    {service.unit && (
                      <span className={`text-xs italic ${
                        isSelected ? 'text-red-600/70' : 'text-slate-500'
                      }`}>
                        {service.unit}
                      </span>
                    )}
                  </div>
                  
                  <div className="flex items-center gap-3">
                    <span className={`text-lg font-bold whitespace-nowrap ${
                      isSelected ? 'text-red-600' : 'text-red-600'
                    }`}>
                      {service.price}
                    </span>
                    
                    <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${
                      isSelected 
                        ? 'bg-red-600 text-white' 
                        : 'bg-slate-100 text-slate-400 group-hover:bg-red-100 group-hover:text-red-500'
                    }`}>
                      {isSelected ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Add-Ons Only Action Button */}
          {selectedAddOns.length > 0 && (
            <div className="flex justify-center mt-4">
              <button
                onClick={handleWhatsAppAddOnsOnly}
                className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-8 py-4 rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-3 transform hover:-translate-y-1"
              >
                <ShoppingCart className="w-5 h-5" />
                Request Add-Ons Only via WhatsApp
                <span className="bg-white/20 px-2 py-0.5 rounded-md text-sm ml-1">
                  {selectedAddOns.length} Selected
                </span>
              </button>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};

export default PackagesComponent;
